import { useEffect, FunctionComponent } from 'react'
import { useDispatch } from 'react-redux'
import { setSignUpModalIsOpen } from 'redux/actions'

const Unauthorized: FunctionComponent = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setSignUpModalIsOpen(true))
  }, [])

  return <span />
}

export default Unauthorized
